var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-section',{attrs:{"theme":"green","title":"國泰產險-傷害險","isHurtInsurance":true,"datas":_vm._.orderBy(
      _vm.highlightModify,
      ['familyrl', 'age', 'ceisdno', 'orderbBySelf', 'ceplcno'],
      ['asc', 'desc', 'asc', 'asc', 'asc']
    ),"_fields":[
      {
        name: '保單號碼',
        key: 'ceplcno',
        width: 155,
        sortable: true,
        orderByMultiKey: ['ceplcno'],
        orderByMultiType: ['asc']
      },
      {
        name: '險種',
        key: 'cepln_nm',
        width: 200,
        sortable: true,
        orderByMultiKey: ['cepln_nm'],
        orderByMultiType: ['asc']
      },
      {
        name: '要保人',
        key: 'ceapcnm',
        width: 80,
        sortable: true,
        orderByMultiKey: ['ceapcnm'],
        orderByMultiType: ['asc']
      },
      {
        name: '被保人',
        key: 'ceisdnm',
        width: 80,
        sortable: true,
        className: 'link text-underline',
        orderByMultiKey: ['ceisdnm'],
        orderByMultiType: ['asc']
      },
      {
        name: '出單日期',
        key: 'cepoldt',
        width: 96,
        sortable: true,
        orderByMultiKey: ['cepoldt'],
        orderByMultiType: ['asc']
      },
      {
        name: '有效期間',
        key: 'ceplcdt',
        width: 111,
        sortable: true,
        orderByMultiKey: ['celpsdt'],
        orderByMultiType: ['desc']
      },
      {
        name: '保費',
        key: 'premium1',
        width: 109,
        sortable: true,
        thClassName: 'text-right',
        className: 'text-right',
        orderByMultiKey: ['premium1'],
        orderByMultiType: ['asc']
      }
    ].concat(_vm._fields),"initShow":_vm.$route.query['CathayPropertyHurtInsuranceShow'] !== 'false'},on:{"toggle":function (isShow) { return _vm.$router.assignQuery({ CathayPropertyHurtInsuranceShow: isShow }); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return _vm.refresh?[_c('data-table',_vm._b({attrs:{"initSort":_vm.$route.query["CathayPropertyHurtInsuranceSort"]
          ? JSON.parse(_vm.$route.query["CathayPropertyHurtInsuranceSort"])
          : null},on:{"changeSort":function (sort) {
              var _obj;

              return _vm.$router.assignQuery(( _obj = {}, _obj["CathayPropertyHurtInsuranceSort"] = JSON.stringify(sort), _obj ));
      }},scopedSlots:_vm._u([{key:"ceplcno",fn:function(item){return [_c('span',{class:{ 'text-blue': item.data.isKeyinBySelf }},[_vm._v(_vm._s(item.data.ceplcno))])]}},{key:"ceapcnm",fn:function(item){return [_c('span',[_vm._v("\n          "+_vm._s(_vm._f("truncate")(item.data.ceapcnm))+"\n        ")])]}},{key:"ceisdnm",fn:function(item){return [_c('span',{on:{"click":function($event){_vm.routeToCustDetail(item.data.ceisdno,item.data.ceisdnm )}}},[_vm._v("\n          "+_vm._s(_vm._f("truncate")(item.data.ceisdnm))+"\n        ")])]}},{key:"cepoldt",fn:function(item){return [_vm._v("\n        "+_vm._s(_vm.getROCDate(item.data.cepoldt))+"\n      ")]}},{key:"ceplcdt",fn:function(item){return [_c('div',{staticClass:"pre-formatted",domProps:{"innerHTML":_vm._s(
            _vm.buildStartEndString(
              _vm.getROCDate(item.data.ceplcdt) + ' ' + item.data.ceplcdt_time,
              _vm.getROCDate(item.data.celpsdt) + ' ' + item.data.celpsdt_time
            )
          )}})]}},{key:"premium1",fn:function(item){return [_vm._v(_vm._s(_vm._f("numberFormat")(item.data.premium1))+"元")]}},{key:"action",fn:function(item){return [_c('a',{staticClass:"text-red text-underline",attrs:{"role":"button"},on:{"click":function($event){_vm.doDelete(item.data)}}},[_vm._v("刪除")])]}}])},'data-table',props,false))]:undefined}}])})}
var staticRenderFns = []

export { render, staticRenderFns }